import { PROJECT_MEDIA_TYPES } from 'consts'
import { PROJECT_AUDIO_TYPES } from 'consts/audio'

export const overlayTypes = [
  PROJECT_MEDIA_TYPES.aiVideo,
  PROJECT_MEDIA_TYPES.aiImage,
  PROJECT_MEDIA_TYPES.aiAvatar,
  PROJECT_AUDIO_TYPES.SOUND,
  PROJECT_AUDIO_TYPES.TTS,
  PROJECT_MEDIA_TYPES.image
]
